import React from "react";
import Page from "Pages/_Layouts/DefaultInternal";
import useGetMetadata from "customHooks/useGetMetadata";
import { useTranslation } from "react-i18next";
import Loading from "customHooks/useCompleoReactHookForm/helpers/Loading";
import FormClassic from "customHooks/useCompleoReactHookForm/components/FormClassic";
import { useAuthState } from "_ReactContext/AuthContext";
import { useApi, useApiCache } from "customHooks/useApi";
import { useCancelButtonForm } from "customHooks/useCancelButtonForm";
import useValuesFromSource from "customHooks/useValuesFromSource";
import { getHandleWorkflowSubmit } from "./jobApprovalWorkflowPostHelper";
import useCompleoReactHookForm, {
    useCompleoReactHookFormGetMainData
} from "customHooks/useCompleoReactHookForm";
import CustomComponents from "./components/JobApprovalWorkflowCustomComponents";
import { useJobApprovalFieldsToHide } from "./utils/useJobApprovalFieldsToHide";
import { useJobApprovalCustomLists } from "./utils/useJobApprovalCustomLists";

const JobApprovalWorkflowEdit = (props: any) => {
    const cancelFunction = useCancelButtonForm("/jobapprovalworkflow/list");
    const { company } = useAuthState();
    const moduleName = "JOBAPPROVALWORKFLOWEDIT";
    const [t, i18n, readyTranslation] = useTranslation(moduleName, {
        useSuspense: false
    });
    const [listDefinition, readyLists] = useJobApprovalCustomLists(t);

    const postAddress = `/jobapprovalworkflow/edit`;
    const [editWorkflowReturn, editWorkflow] = useApi(postAddress, "post");
    const [metadata] = useGetMetadata(moduleName);

    const postAddressSearch = `/jobapprovalworkflow/search`;
    const [getWorkflowSearchResult] = useApiCache(
        postAddressSearch,
        "post",
        { uuid: props.uuid, companyId: company.companyId },
        false
    );

    const [valuesFromSource] = useValuesFromSource(
        metadata,
        true,
        {},
        getWorkflowSearchResult,
        ["data", "data", "Items"]
    );
    valuesFromSource.uuid = props.uuid;
    valuesFromSource.deleted = false;
    const ready =
        readyTranslation &&
        getWorkflowSearchResult.status === "success" &&
        metadata.status === "success" &&
        readyLists;

    const handleSubmit = getHandleWorkflowSubmit(editWorkflow);
    const reactHookFormMethods = useCompleoReactHookFormGetMainData({
        t,
        ready: ready,
        i18nV: i18n,
        metadadosRetorno: metadata,
        valuesFromSource: valuesFromSource
    });
    const { watch } = reactHookFormMethods.reactHookFormMethods;
    const fieldsToHide = useJobApprovalFieldsToHide(watch);
    const [formCompleo, finished] = useCompleoReactHookForm({
        t: t,
        ready,
        i18nV: i18n,
        postMethod: handleSubmit,
        postReturn: editWorkflowReturn,
        redirectAddress: "/jobapprovalworkflow/list",
        FormType: FormClassic,
        metadadosRetorno: metadata,
        valuesFromSource,
        CustomComponents,
        secondaryButtonFunction: cancelFunction,
        fieldsToHide,
        customLists: listDefinition,
        reactHookFormMethods
    });

    let compRetorno: boolean | JSX.Element;
    compRetorno = <Loading />;

    if (finished && readyTranslation) {
        compRetorno = formCompleo;
        return (
            <Page
                featureName={t("a_FeatureName")}
                featureMainDescription={t("a_FeatureMainDescription")}
                maxWidth="md"
            >
                {compRetorno}
            </Page>
        );
    } else {
        return <Page>{compRetorno}</Page>;
    }
};

export default JobApprovalWorkflowEdit;
